import { GameFreeSpinsOverlayProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameFreeSpinsOverlayProperties";
import { GameStyle } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/style/GameStyle";
import { Modules } from "@lib/titan2/dist/game/Constants";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { Point } from "pixi.js";
/**
 * FreeSpinsOverlayLandscapeProperties.ts
 */
export class FreeSpinsOverlayLandscapeProperties extends GameFreeSpinsOverlayProperties {
    constructor() {
        super();
        this.collectionSpineProperties = new SpineProperties(GameStyle.DAB_TRAIL_LONG, Modules.GAME);
        this.endTrailBodgeOffset = [0, 1, 2, 3, 4].map(_ => new Point(10, 60));
        this.targetPositions = [0, 1, 2, 3, 4].map(_ => [new Point(565, 501), new Point(795, 385)]);
        this.maxRandomness = 20;
        this.position.set(973, 557);
        this.scale.set(0.73);
    }
}
//# sourceMappingURL=FreeSpinsOverlayLandscapeProperties.js.map